import apiService from './apiService';
import apiServiceNew from './apiService.new';

export default (function() {
	var versionTrackPath = '/versionTrack';

	function shared(token, mediaId) {
		var url = versionTrackPath + '/' + token + '/shared'
			+ apiService.paramsToQuery({
				mediaId: mediaId
			});

		return apiService.get(url);
	}

	function list(mediaId, version) {
		var url = versionTrackPath + apiService.paramsToQuery({
			mediaId: mediaId, version: version
		});

		return apiService.get(url);
	}

	function create(info) {
		return apiServiceNew.post(versionTrackPath, info).then(res => res.data);
	}

	function deleteTrack(id) {
		return apiServiceNew.delete(`${versionTrackPath}/${id}`);
	}

	return {
		shared,
		list,
		create,
		delete: deleteTrack
	};
})();